import { Radio } from "lucide-react";
import { useStore } from "zustand";
import { Button } from "@/components/ui/button";
import { authStore } from "@/lib/stores/auth-store";
import { coreStore } from "@/lib/stores/core-store";
import { uiStore } from "@/lib/stores/ui-store";

export function BroadcastStatus() {
	const user = useStore(authStore, (state) => state.user);
	const broadcast = useStore(coreStore, (state) => state.broadcast);
	const navigate = useStore(uiStore, (state) => state.navigate);

	if (!broadcast || user?.uid !== broadcast.startedBy) {
		return null;
	}

	return (
		<div className="rounded-lg border bg-card p-3">
			<Button
				className="!px-1 h-auto w-full cursor-pointer justify-start gap-2 py-1.5"
				onClick={() => navigate({ type: "broadcastControls" })}
				variant="ghost"
			>
				<Radio className="size-3.5 text-red-500" />
				<div className="flex flex-1 items-center justify-between overflow-hidden">
					<p className="truncate font-medium text-sm">{broadcast.title}</p>
					<span
						className={`whitespace-nowrap rounded px-1.5 py-0.5 font-medium text-xs ${
							broadcast.status === "live"
								? "bg-red-500/20 text-red-500"
								: "bg-yellow-500/20 text-yellow-500"
						}`}
					>
						{broadcast.status === "live" ? "LIVE" : "PAUSED"}
					</span>
				</div>
			</Button>
		</div>
	);
}
